export const TIMEZONE_OPTIONS = [
    { code: 'Pacific/Midway', offset: 'UTC-11:00', label: '(UTC-11:00) Coordinated Universal Time-11' },

    { code: 'US/Aleutian', offset: 'UTC-10:00', label: '(UTC-10:00) Aleutian Islands' },
    { code: 'Pacific/Honolulu', offset: 'UTC-10:00', label: '(UTC-10:00) Hawaii' },

    { code: 'Pacific/Marquesas', offset: 'UTC-09:30', label: '(UTC-09:30) Marquesas Islands' },
    { code: 'Pacific/Gambier', offset: 'UTC-09:00', label: '(UTC-09:00) Coordinated Universal Time-09' },
    { code: 'America/Juneau', offset: 'UTC-09:00', label: '(UTC-09:00) Alaska' },

    { code: 'America/Tijuana', offset: 'UTC-08:00', label: '(UTC-08:00) Baja California' },
    { code: 'America/Los_Angeles', offset: 'UTC-08:00', label: '(UTC-08:00) Pacific Time (US and Canada)' },
    { code: 'Pacific/Pitcairn', offset: 'UTC-08:00', label: '(UTC-08:00) Coordinated Universal Time-08' },

    { code: 'America/Denver', offset: 'UTC-07:00', label: '(UTC-07:00) Mountain Time (US and Canada)' },
    { code: 'America/Chihuahua', offset: 'UTC-07:00', label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan' },
    { code: 'America/Phoenix', offset: 'UTC-07:00', label: '(UTC-07:00) Arizona' },

    { code: 'Chile/EasterIsland', offset: 'UTC-06:30', label: '(UTC-06:30) Easter Island' },
    { code: 'America/Chicago', offset: 'UTC-06:00', label: '(UTC-06:00) Central America, Central Time (US and Canada)' },
    { code: 'Canada/Saskatchewan', offset: 'UTC-06:00', label: '(UTC-06:00) Saskatchewan' },
    { code: 'America/Mexico_City', offset: 'UTC-06:00', label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey' },

    { code: 'America/New_York', offset: 'UTC-05:00', label: '(UTC-05:00) Chetumal, Haiti, Turks and Caicos, Eastern Time (US and Canada)' },
    { code: 'America/Havana', offset: 'UTC-05:00', label: '(UTC-05:00) Havana' },
    { code: 'America/Indiana/Indianapolis', offset: 'UTC-05:00', label: '(UTC-05:00) Indiana (East)' },
    { code: 'America/Lima', offset: 'UTC-05:00', label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco' },

    { code: 'America/Caracas', offset: 'UTC-04:00', label: '(UTC-04:00) Caracas' },
    { code: 'America/Santiago', offset: 'UTC-04:00', label: '(UTC-04:00) Atlantic Time (Canada), Santiago' },
    { code: 'America/Asuncion', offset: 'UTC-04:00', label: '(UTC-04:00) Asuncion' },
    { code: 'America/Cuiaba', offset: 'UTC-04:00', label: '(UTC-04:00) Cuiaba' },
    { code: 'America/La_Paz', offset: 'UTC-04:00', label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan' },

    { code: 'America/St_Johns', offset: 'UTC-03:30', label: '(UTC-03:30) Newfoundland' },

    { code: 'America/Araguaina', offset: 'UTC-03:00', label: '(UTC-03:00) Araguaina' },
    { code: 'America/Montevideo', offset: 'UTC-03:00', label: '(UTC-03:00) Montevideo' },
    { code: 'America/Argentina/Buenos_Aires', offset: 'UTC-03:00', label: '(UTC-03:00) City of Buenos Aires' },
    { code: 'America/Fortaleza', offset: 'UTC-03:00', label: '(UTC-03:00) Cayenna, Fortaleza' },
    { code: 'America/Punta_Arenas', offset: 'UTC-03:00', label: '(UTC-03:00) Punta Arenas' },
    { code: 'America/Miquelon', offset: 'UTC-03:00', label: '(UTC-03:00) Saint Pierre and Miquelon, Greenland' },
    { code: 'America/El_Salvador', offset: 'UTC-03:00', label: '(UTC-03:00) Salvador, Brasilia' },

    { code: 'America/Noronha', offset: 'UTC-02:00', label: '(UTC-02:00) Coordinated Universal Time-02' },

    { code: 'Atlantic/Azores', offset: 'UTC-01:00', label: '(UTC-01:00) Azores' },
    { code: 'Atlantic/Cape_Verde', offset: 'UTC-01:00', label: '(UTC-01:00) Cabo Verde Islands' },

    { code: 'Europe/London', offset: 'UTC', label: '(UTC) Dublin, Edinburgh, Lisbon, London' },
    { code: 'Africa/Sao_Tome', offset: 'UTC', label: '(UTC) Sao Tome' },
    { code: 'Africa/Monrovia', offset: 'UTC', label: '(UTC) Monrovia, Reykjavik' },
    { code: 'UTC', offset: 'UTC', label: '(UTC) Coordinated Universal Time' },
    { code: 'Africa/Casablanca', offset: 'UTC', label: '(UTC) Casablanca' },

    { code: 'Europe/Belgrade', offset: 'UTC+01:00', label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague' },
    { code: 'Europe/Zagreb', offset: 'UTC+01:00', label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb' },
    { code: 'Europe/Paris', offset: 'UTC+01:00', label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris' },
    { code: 'Europe/Berlin', offset: 'UTC+01:00', label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' },
    { code: 'Africa/Brazzaville', offset: 'UTC+01:00', label: '(UTC+01:00) West Central Africa' },

    { code: 'Europe/Helsinki', offset: 'UTC+02:00', label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius' },
    { code: 'Europe/Athens', offset: 'UTC+02:00', label: '(UTC+02:00) Athens, Bucharest' },
    { code: 'Asia/Jerusalem', offset: 'UTC+02:00', label: '(UTC+02:00) Jerusalem' },
    { code: 'Africa/Cairo', offset: 'UTC+02:00', label: '(UTC+02:00) Cairo' },

    { code: 'Europe/Moscow', offset: 'UTC+03:00', label: '(UTC+03:00) Moscow, St. Petersburg' },
    { code: 'Asia/Baghdad', offset: 'UTC+03:00', label: '(UTC+03:00) Baghdad' },
    { code: 'Asia/Tehran', offset: 'UTC+03:30', label: '(UTC+03:30) Tehran' },

    { code: 'Asia/Dubai', offset: 'UTC+04:00', label: '(UTC+04:00) Abu Dhabi, Muscat' },
    { code: 'Asia/Kabul', offset: 'UTC+04:30', label: '(UTC+04:30) Kabul' },

    { code: 'Asia/Kolkata', offset: 'UTC+05:30', label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi' },

    { code: 'Asia/Bangkok', offset: 'UTC+07:00', label: '(UTC+07:00) Bangkok, Hanoi, Jakarta' },

    { code: 'Asia/Beijing', offset: 'UTC+08:00', label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi' },
    { code: 'Asia/Tokyo', offset: 'UTC+09:00', label: '(UTC+09:00) Osaka, Sapporo, Tokyo' },

    { code: 'Australia/Sydney', offset: 'UTC+10:00', label: '(UTC+10:00) Canberra, Melbourne, Sydney' },

    { code: 'Pacific/Auckland', offset: 'UTC+12:00', label: '(UTC+12:00) Auckland, Wellington' },

    { code: 'Pacific/Kiritimati', offset: 'UTC+14:00', label: '(UTC+14:00) Kiritimati Island' }
];
